import isServer from './utils/isServer';

// the API URL of the target app.
// example: https://www.paperlesspost.com or https://earth.paperlesspost.com
// see tests to understand scenarios this covers.
export const getAppUrl = () =>
  !isServer()
    ? process.env.REACT_APP_BASE_URL || window.location.origin
    : process.env.API_HOST || process.env.REACT_APP_BASE_URL;

// the GraphQL URL which will differ between client and server side
export const getGraphQLUrl = () =>
  !process.env.GRAPHQL_API_URL
    ? `${getAppUrl()}/flyer/api/graphql`
    : `${process.env.GRAPHQL_API_URL}/graphql`;

// the API URL which will differ between client and server side
export const getApiUrl = () =>
  process.env.RAILS_API_URL || `${getAppUrl()}/api/v1`;
